import { Stack, useTheme } from "@mui/material";
import { FoodsIcon, FoodsTooltip, Typography } from "@foodpilot/foods";
import type { AuditLogEntry } from "src/api/client-api/auditLog/auditLogSchemas";
import { isServiceActor } from "./auditLogPresentation";
import { useAuditLogLabels } from "./useAuditLogLabels";

type ActorBadgeProps = {
    entry: AuditLogEntry;
};

export const ActorPictogram = (props: ActorBadgeProps) => {
    const { entry } = props;
    const labels = useAuditLogLabels();

    return (
        <FoodsTooltip title={labels.actorType(entry.actorType)}>
            <Stack justifyContent="center" alignItems="center" flexShrink={0}>
                <FoodsIcon icon={isServiceActor(entry) ? "settings" : "users"} size={2} />
            </Stack>
        </FoodsTooltip>
    );
};

export const ActorBadge = (props: ActorBadgeProps) => {
    const { entry } = props;
    const theme = useTheme();
    const labels = useAuditLogLabels();

    return (
        <Stack direction="row" gap={theme.spacing(1)} alignItems="center" overflow="hidden">
            <ActorPictogram entry={entry} />
            <Typography variant="small-regular" noWrap>
                {entry.actorLabel ?? labels.actorType(entry.actorType)}
            </Typography>
        </Stack>
    );
};
